import { HeapCustomEvent } from 'config';
import { PaymentService, PaymentUpdateFunnel } from '../../utils/config';

const heapPaymentUpdateEvents = {
  [PaymentService.CREDIT_CARD]: {
    [PaymentUpdateFunnel.STANDARD_SIGNUP]: HeapCustomEvent.SIGNUP_SUCCESS_CREDIT_CARD,
    [PaymentUpdateFunnel.EXPRESS_SIGNUP]: null,
    [PaymentUpdateFunnel.USER_PROFILE]: HeapCustomEvent.PROFILE_SUCCESS_CREDIT_CARD,
  },
  [PaymentService.PAYPAL]: {
    [PaymentUpdateFunnel.STANDARD_SIGNUP]: HeapCustomEvent.SIGNUP_SUCCESS_PAYMENT_PAYPAL,
    [PaymentUpdateFunnel.EXPRESS_SIGNUP]: HeapCustomEvent.SIGNUP_SUCCESS_EXPRESS_PAYPAL,
    [PaymentUpdateFunnel.USER_PROFILE]: HeapCustomEvent.PROFILE_SUCCESS_PAYPAL,
  },
  [PaymentService.GOOGLE_PAY]: {
    [PaymentUpdateFunnel.STANDARD_SIGNUP]: HeapCustomEvent.SIGNUP_SUCCESS_PAYMENT_GOOGLE_PAY,
    [PaymentUpdateFunnel.EXPRESS_SIGNUP]: HeapCustomEvent.SIGNUP_SUCCESS_EXPRESS_GOOGLE_PAY,
    [PaymentUpdateFunnel.USER_PROFILE]: HeapCustomEvent.PROFILE_SUCCESS_GOOGLE_PAY,
  },
  [PaymentService.APPLE_PAY]: {
    [PaymentUpdateFunnel.STANDARD_SIGNUP]: HeapCustomEvent.SIGNUP_SUCCESS_PAYMENT_APPLE_PAY,
    [PaymentUpdateFunnel.EXPRESS_SIGNUP]: HeapCustomEvent.SIGNUP_SUCCESS_EXPRESS_APPLE_PAY,
    [PaymentUpdateFunnel.USER_PROFILE]: HeapCustomEvent.PROFILE_SUCCESS_APPLE_PAY,
  },
  [PaymentService.VENMO]: {
    [PaymentUpdateFunnel.STANDARD_SIGNUP]: HeapCustomEvent.SIGNUP_SUCCESS_PAYMENT_VENMO,
    [PaymentUpdateFunnel.EXPRESS_SIGNUP]: null,
    [PaymentUpdateFunnel.USER_PROFILE]: HeapCustomEvent.PROFILE_SUCCESS_VENMO,
  },
};

export const heapTrackReviewSubmitted = ({
  productId,
  skuId,
  userId,
  createdAt,
  starRating,
  totalMediaAttached,
}: {
  productId: number;
  skuId: number;
  userId: number;
  createdAt: string;
  starRating: number;
  totalMediaAttached: number;
}): void => {
  if (!window.heap) return;
  window.heap.track(HeapCustomEvent.REVIEW_SUBMITTED, {
    product_id: productId,
    sku_id: skuId,
    user_id: userId,
    created_at: createdAt,
    star_rating: starRating,
    total_media_attached: totalMediaAttached,
  });
};

export const heapTrackSuccessfullyAuthPayment = (funnel: PaymentUpdateFunnel,
  service: PaymentService): void => {
  const heapEvent = heapPaymentUpdateEvents[service][funnel];
  if (!heapEvent || !window.heap) return;
  window.heap.track(heapEvent, {
    signup_payment_funnel: funnel,
    payment_service: service,
  });
};
